<template>
  <div class="calendar-adweek-task">
    <div
      :ref="`task${item.id}`"
      v-for="item in realItems"
      :key="item.id"
      class="calendar-adweek-task-block"
      :class="{
        'calendar-adweek-task-new': !item.id,
        'calendar-adweek-task-done': item.state === 1,
        'calendar-adweek-task-expired': item.expired
      }"
      :style="{
        width: `${size*item.width - 8}px`,
        left: `${item.left*size}px`,
        top: `${item.top*22 + 4}px`
      }"
      :draggable="item.state!==TASK_DETAIL.STATE_FINISHED"
      @dragstart="startDrag(item, $event)"
    >
      <el-popover
        v-model="item.triggered"
        placement="right"
        trigger="hover"
      >
        <div
          slot="reference"
          class="calendar-adweek-task-trigger"
          :class="{
            'triggered': item.triggered
          }"
        >
          <em
            v-if="item.state === TASK_DETAIL.STATE_FINISHED"
            class="ibass ibass-done"
          />
          <span class="calendar-adweek-task-label">{{ item.name }}</span>
        </div>
        <task-info
          v-if="item.triggered"
          :task="item"
          @close="item.triggered=false"
        />
      </el-popover>
    </div>
  </div>
</template>
<script>
import TaskInfo from './taskInfo'
import { TASK_DETAIL } from '@/utils/constants'
/* eslint-disable-next-line */
import Worker from 'workerize-loader!@/plugin/worker/calendar'
export default {
  name: 'CalendarWeekTask',
  components: {
    TaskInfo
  },
  props: {
    tasks: {
      type: Array,
      default: function () {
        return []
      }
    },
    monday: {
      type: Number
    },
    size: {
      type: Number,
      default: 90
    },
    isMore: {
      type: Boolean,
      default: false
    },
    levelNum: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      items: this.tasks,
      TASK_DETAIL,
      pageX: -1,
      calendarTickCallback: [], // 日历收集一个tick之后的回调
      calendarWorker: null // 日历计算的worker，单例
    }
  },
  computed: {
    realItems () {
      let array = this.isMore ? this.items.slice(0, 200) : this.items
      return array.filter(item => {
        return item.top < this.levelNum && item.name
      })
    }
  },
  watch: {
    tasks (newVal) {
      this.updateTask(newVal)
    }
  },
  methods: {
    startDrag (item, event) {
      // 月视图下拖拽bug处理临时方案，Tapd地址： https://www.tapd.cn/20473721/bugtrace/bugs/view?bug_id=1120473721001030978&url_cache_key=45b60dc02aa4da0c025186cff8eefbf7； https://www.tapd.cn/20473721/bugtrace/bugs/view?bug_id=1120473721001030977&url_cache_key=45b60dc02aa4da0c025186cff8eefbf7
      event.dataTransfer.setDragImage(this.$refs[`task${item.id}`][0], 10, 10)
      this.$store.commit('setDraggingTask', item)
    },
    updateTask (tasks) {
      if (this.calendarTickCallback.length) {
        this.calendarTickCallback = []
      }
      if (!this.calendarWorker) {
        this.calendarWorker = Worker()
      }
      this.$nextTick(() => {
        this.calendarTickCallback.push(this.calendarWorker.getTasks(tasks, this.monday))
        Promise.all(this.calendarTickCallback).then(([res]) => {
          if (res.type === 'calendarTasksResult') {
            this.items = res.array || []
          }
        })
      })
    }
    // updateTask1 (tasks) {
    //   let tempTasks = this.transformTask(tasks)
    //   tempTasks = this.sortTasks(tempTasks, ['startDay', 'createOrder', 'endDay', 'state'], ['asc', 'asc', 'desc', 'asc'])
    //   this.items = this.setTaskPosition(tempTasks)
    // },
    /**
     * 给每个任务添加属性startDay： 开始日期，不区分时分秒
     * 给每个任务添加属性endDay： 结束日期，不区分时分秒
     * 判断任务过期
     */
    // transformTask (arr) {
    //   let array = _.cloneDeep(arr)
    //   array.map((item) => {
    //     const startTime = item.startTime || item.dueTime
    //     const endTime = item.endTime || item.dueTime

    //     item.startDay = Math.max(moment(startTime).startOf('day').valueOf(), moment(this.monday).valueOf())
    //     item.endDay = moment(endTime).endOf('day').valueOf()
    //     item.used = false
    //     item.isSchedule = !!item.dueTime
    //   })
    //   return array
    // },
    // sortTasks (array, columns, orders) {
    //   array = _.orderBy(array, columns, orders)
    //   return array
    // },
    // setTaskPosition (array) {
    //   let endWeek = moment(this.monday).endOf('week')
    //   let startDay = moment(this.monday).startOf('day')
    //   for (let i in array) {
    //     let aStartDay = array[i].startDay
    //     let minEndTime = moment.min(moment(array[i].endDay), endWeek)
    //     let maxStartTime = moment(aStartDay)
    //     array[i].width = Math.max(minEndTime.diff(maxStartTime.startOf('day'), 'days') + 1, 1)
    //     array[i].left = maxStartTime.diff(startDay, 'days')
    //     array[i].top = 0

    //     // 将已经排完的任务按照top排序
    //     const topArray = this.sortTasks(array.slice(0, i), ['top'], ['asc'])
    //     for (let j = 0; j < i; j++) {
    //       if (!topArray[j].used && maxStartTime.isAfter(moment(topArray[j].endDay), 'day')) {
    //         array[i].top = topArray[j].top
    //         topArray[j].used = true
    //         break
    //       } else {
    //         array[i].top = topArray[j].top + 1
    //       }
    //     }
    //   }
    //   return array
    // }
  }
}
</script>
<style lang="stylus">
.calendar-adweek-task
  &-block
    position absolute
    background-color #FCF4DB
    margin 5px 0 0 5px
    display flex
    justify-content flex-start
    align-items flex-start
    flex-wrap nowrap
    font-size .75rem
    border-radius 2px
    cursor pointer
    &>span
      width 100%
  &-done
    background-color #f8f8f9
    .calendar-adweek-task-label
      color #999
      text-decoration line-through
    .ibass-done
      color #999
  &-trigger
    padding 0 4px 0 8px
    display flex
    width 100%
    height 16px
    white-space nowrap
    outline none
    box-sizing border-box
    &.triggered
      background-color #FFD9B9
      border-radius 2px
    .ibass-done
      width 12px
      margin-top 2px
      margin-right 3px
  &-label
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    font-size 10px
    color #ED6C00
</style>
